// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { satoshiVMTestnet as _satoshiVMTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the satoshiVMTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 3110
 * Chain Name: SatoshiVM Testnet
 * Default Block Explorer: https://testnet.svmscan.io
 * Default RPC URL: https://test-rpc-node-http.svmscan.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { satoshiVMTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: satoshiVMTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const satoshiVMTestnet = createCommon({
	..._satoshiVMTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
